module.exports = __webpack_public_path__ + "img/ico-overview.f86a22bb.svg";